import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Toast } from 'ngx-toastr';
import { BaseComponent } from 'src/app/base/base.component';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Config } from 'src/infrastructure/config';
import { Successes } from 'src/infrastructure/labels/successes';
import { Validator } from 'src/infrastructure/validation/validator';
import { CarrierAddressItem } from 'src/models/DTO/carrier/carrierAddressItem';
import { FullContactV2 } from 'src/models/DTO/contact/fullContactV2';
import { PlainContactV2 } from 'src/models/DTO/contact/plainContactV2';
import { UserDTO } from 'src/models/DTO/user/user';
import { ContactRequestModel } from 'src/models/requestModels/contact/contactRequestModel';
import { ToastService } from 'src/services/core/toast/toast.service';
import { ContactService } from 'src/services/request/contact/contact.service';
import { SpeedyService } from 'src/services/request/speedy/speedy.service';
import { HistoryService } from 'src/services/state/history/history.service';
import { LoggedUserService } from 'src/services/state/loggeduser/loggeduser.service';

@Component({
  selector: 'app-orderaddressedit',
  templateUrl: './orderaddressedit.component.html',
  styleUrls: ['./orderaddressedit.component.css']
})
export class OrderaddresseditComponent extends HistoryBaseComponent implements OnInit {

  private _section = 'person';
  private _isAddressForInvoice = false;
  private _addressInfo: FormGroup;
  private _loggedUser?: UserDTO;
  private _cities: CarrierAddressItem = {
    data: {
      results: []
    }
  };
  private _streets: CarrierAddressItem = {
    data: {
      results: []
    }
  };
  private _cityKey = 0;
  private _editMode = false;
  private _editedContact = '';
  private _formBuilder: FormBuilder;
  private _title =  'Добави адрес';
  private _type =  Config.shipping;


  public cityQuery =  false;
  public streetQuery =  false;
  public city =  '';
  public street =  '';
  public btnText =  'Запази';
  public hasVatNumber = false;
  public postalCodeError = false;

  constructor(
    private FB: FormBuilder,
    private contactsService: ContactService,
    private loggedUserService: LoggedUserService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private speedyService: SpeedyService,
    private toastr: ToastService,
    protected location: Location,
    protected historyService: HistoryService
  ) {
    super(location, historyService);
    this._formBuilder = FB;
    this.loggedUserService.userInfo$.subscribe((user) => {
      this._loggedUser = user;
    });
    this._addressInfo = this._formBuilder.group({
      first_name: ['', [Validators.required]],
      last_name: ['', [Validators.required]],
      phone: ['', [Validators.required]],
      city: ['', [Validators.required]],
      residence: [''],
      street: ['', [Validators.required]],
      streetNumber: ['', [Validators.required]],
      postalCode: ['', [Validators.required, Validators.pattern(/^\d{4}$/)]],
    });

    this._addressInfo.get('postalCode')?.valueChanges.subscribe(value => {
      this.validatePostalCode();
    });
  }

  ngAfterViewInit(): void {
    const inputs = document.querySelectorAll<HTMLInputElement>('input');
    inputs.forEach(input => {
      input.focus({ preventScroll: true });
    });
  }

  ngOnInit(): void {
    this.loggedUserService.userInfo$.subscribe((user) => {
      if (!Object.keys(user).length) { return; }
      this._loggedUser = user;
      this.activatedRoute.params.subscribe(params => {
        if (params.type === Config.invoice) { this._isAddressForInvoice = true; }
        this._type = params.type;
        if (!params.id) { return; }
        this._editMode = true;
        this._title = 'Редактирай адрес';
        this.btnText = 'Запази промените';
        this._editedContact = params.id;
        this.contactsService.getFullContactInfoForEntity(this._editedContact).subscribe(contact => {
          if ([Config.invoiceCompanyLocationRole, Config.invoiceUserLocationRole].includes(contact.data.type.label)) {
            if (Config.invoiceCompanyLocationRole === contact.data.type.label) {
              this.section = 'firm';
              this.registerCompanyContactForEdit(contact);
            }
            else {
              this.registerContactForEdit(contact);
            }
          }
          else {
            this.registerContactForEdit(contact);
          }
        });
      });
    });
  }
  validatePostalCode(): void {
    const postCodeValue = this._addressInfo.get('postalCode')?.value;
    console.log('this._addressInfo.get(\'postCode\')?.value;', this._addressInfo.get('postalCode')?.value);
    this.postalCodeError = !!(!/^\d{4}$/.test(postCodeValue) && postCodeValue);
  }
  get title(): string {
    if (this._isAddressForInvoice) {
      if (this._editMode) {
        return 'Редактирай данни';
      }
      return 'Добави данни за фактура';
    }
    if (this._editMode) {
      return 'Редактирай адрес';
    }
    return 'Добави адрес 1';
  }

  private setPersionalFormGroup(): void {
    this._addressInfo = this._formBuilder.group({
      first_name: ['', [Validators.required]],
      last_name: ['', [Validators.required]],
      phone: ['', [Validators.required]],
      city: ['', [Validators.required]],
      residence: [''],
      street: ['', [Validators.required]],
      streetNumber: ['', [Validators.required]],
      postalCode: [''],
    });
  }

  private setCompanyFormGroup(): void {
    this._addressInfo = this._formBuilder.group({
      company_name: ['', [Validators.required]],
      company_number: ['', [Validators.required]],
      company_owner: ['', [Validators.required]],
      city: ['', [Validators.required]],
      residence: [''],
      company_vat_number: [''],
      postalCode: [''],

    });
  }

  private registerContactForEdit(contact: FullContactV2): void {
    const name = contact.data.name?.split(' ') || ['', ''];
    this._addressInfo = this.FB.group({
      first_name: [name[0], [Validators.required]],
      last_name: [name[1], [Validators.required]],
      phone: [contact.data.mobile_phone_1_e164, [Validators.required]],
      city: [contact.data.city, [Validators.required]],
      residence: [contact.data.address_line_2],
      street: [contact.data.street_name, [Validators.required]],
      streetNumber: [contact.data.street_number, [Validators.required]],
      postalCode: [contact.data.post_code],
    });
    Object.keys(this._addressInfo.controls).forEach(controlKey => {
      this._addressInfo.get(controlKey)?.markAsDirty();
    });
    this.city = contact.data.city;
    this.street = contact.data.street_name;

  }

  private registerCompanyContactForEdit(contact: FullContactV2): void {
    if (contact.data.company_vat_number) {
      this.hasVatNumber = true;
    }
    this._addressInfo = this.FB.group({
      company_name: [contact.data.company_name, [Validators.required]],
      company_number: [contact.data.company_number, [Validators.required]],
      city: [contact.data.city, [Validators.required]],
      residence: [contact.data.address_line_2],
      company_owner: [contact.data.company_owner, [Validators.required]],
      company_vat_number: [contact.data.company_vat_number],
      postalCode: [contact.data.post_code,  [Validators.required]],
    });
    Object.keys(this._addressInfo.controls).forEach(controlKey => {
      this._addressInfo.get(controlKey)?.markAsDirty();
    });
  }

  private getTypeOfContact() {
    if (this._isAddressForInvoice) {
      if (this._section === 'person') {
        return Config.invoiceUserLocationRole;
      }
      return Config.invoiceCompanyLocationRole;
    }
    return Config.userLocationRole;
  }

  private getVatNumber() {
    if (this.hasVatNumber) {
      return this._addressInfo.get('company_vat_number')?.value;
    }
    return undefined;
  }

  private redirectToAddresses(): void {
    if (this._isAddressForInvoice) {
      this.router.navigate(['order/adderess/select/INVOICE']);
    }
    else {
      this.router.navigate(['order/adderess/select/SHIPPING']);
    }
  }

  get addressInfo() {
    return this._addressInfo;
  }

  get cities() {
    return this._cities;
  }

  get streets() {
    return this._streets;
  }

  get editMode() {
    return this._editMode;
  }

  get isAddressForInvoice() {
    return this._isAddressForInvoice;
  }

  set section(value: string)  {
    this._section = value;
  }

  get section() {
    return this._section;
  }

  private getPersonalName() {
    if (this._addressInfo.get('first_name')?.value  && this._addressInfo.get('last_name')?.value) {
      return this._addressInfo.get('first_name')?.value + ' ' + this._addressInfo.get('last_name')?.value
    }
    return '';
  }

  changeSection(section: string) {
    if (this._editMode) { return; }
    this._section = section;
    if (section === 'person') {
      this.setPersionalFormGroup();
    }
    else {
      this.setCompanyFormGroup();
    }
  }

  delete(): void {
    this.contactsService.deleteContact(this._editedContact).subscribe(() => {
      this.toastr.success(Successes.bg.removeContact);
      this.router.navigate(['order/adderess/select/' + this._type]);
    });
  }

  selectCity($event: any): void {
    this._cityKey = $event.value.key;
    this.city = $event.value.value;
    this._addressInfo.get('city')?.setValue($event.value.value)
  }

  selectStreet($event: any): void {
    this.street = $event.value.value;
    this._addressInfo.get('street')?.setValue($event.value)
  }

  loadCities(event: any): void {
    if (!event.target.value) {
      this.cityQuery = false;
      this._cities = { data: { results: [] }};
      return;
    }
    this.cityQuery = true;
    this.speedyService.searchCarrierCity(100, event.target.value).subscribe(cities => {
      this._cities = cities;
    });
  }

  loadStreets(event: any): void {
    if (!event.target.value) {
      this.streetQuery = false;
      this._streets = { data: { results: [] }};
      return;
    }
    this.streetQuery = true;
    this.speedyService.searchCarrierOffice(this._cityKey, event.target.value).subscribe(streets => {
      this._streets = streets;
    });
  }



  createAddress(): void {
    const contactRequestModel: ContactRequestModel = {
      country_uuid: 'fee09419-17d4-4ec0-bf7d-a3b12b5a5cc9',
      contactable_type: Config.user,
      contactable_uuid: this._loggedUser!.data.uuid,
      type:  this.getTypeOfContact(),
      city: this._addressInfo.get('city')?.value,
      contact_person_first_name: this._addressInfo.get('first_name')?.value,
      contact_person_last_name: this._addressInfo.get('first_name')?.value,
      postcode: this._addressInfo.get('postalCode')?.value,
      street_name:  this._addressInfo.get('street')?.value,
      street_number:  this._addressInfo.get('streetNumber')?.value,
      address_line_1: this._addressInfo.get('residence')?.value,
      address_line_2: this._addressInfo.get('residence')?.value,
      mobile_phone_1: this._addressInfo.get('phone')?.value,
      mobile_phone_1_country_code: (this._isAddressForInvoice && this._section === 'firm') ? '' : 'BG',
      name: this.getPersonalName(),
      company_name: this._addressInfo.get('company_name')?.value,
      company_number: this._addressInfo.get('company_number')?.value,
      company_owner: this._addressInfo.get('company_owner')?.value,
      company_vat_number: this.getVatNumber(),
    };
    if (this._editMode) {
      this.contactsService.updatePartnerContact(contactRequestModel, this._editedContact).subscribe(() => {
        this.toastr.success(Successes.bg.updateContact);
        this.redirectToAddresses();
      });
    }
    else {
      this.contactsService.registerUserContact(contactRequestModel).subscribe(() => {
        this.toastr.success(Successes.bg.addContact);
        this.redirectToAddresses();
      });
    }
  }

}
